export const formatDate = (
  dateString: string | Date | undefined,
  withTime: boolean = false,
): string => {
  if (!dateString) return '';

  const date = new Date(dateString);

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  let formatted = `${day}/${month}/${year}`;

  if (withTime) {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    formatted += ` ${hours}:${minutes}:${seconds}`;
  }

  return formatted;
};

/* Date -> 'yyyy-MM-dd' en hora local (para query params y backend) */
export const toLocalISO = (d: Date): string => {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

/* 'yyyy-MM-dd' -> Date local (evita el corrimiento por UTC) */
export const parseLocalISO = (s: unknown): Date | undefined => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s));
  if (!m) return undefined;
  const d = new Date(+m[1], +m[2] - 1, +m[3]);
  return isNaN(d.getTime()) ? undefined : d;
};

/* Toma día actual */
export const hoy = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
};